import { useTranslation } from "react-i18next";
import { CssBaseline } from "@mui/material";
import theme from "./Theme";

const NotFoundPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <CssBaseline />
      <div
        style={{
          padding: "100px 20px",
          textAlign: "center",
          backgroundColor: theme.palette.text.secondary,
          color: theme.palette.primary.main,
        }}
      >
        <h1>404 - {t("NotFoundPage.Page Not Found")}</h1>
        <p>{t("NotFoundPage.The page you are looking for does not exist.")}</p>
      </div>
    </>
  );
};

export default NotFoundPage;
